const Poi = () =>
  import(
    /* webpackChunkName: "base-info-poi-poi" */ '@/pages/base-info/poi/poi/index.vue'
  )
const CreatePoi = () =>
  import(
    /* webpackChunkName: "base-info-poi-poi" */ '@/pages/base-info/poi/poi/create.vue'
  )
const EditPoi = () =>
  import(
    /* webpackChunkName: "base-info-poi-poi" */ '@/pages/base-info/poi/poi/edit.vue'
  )

export default {
  path: 'poi',
  meta: {
    label: 'poi',
    auth: 'poi'
  },
  component: {
    name: 'Poi',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoPoiPoi',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Poi
    },
    {
      name: 'BaseInfoCreatePoiPoi',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreatePoi
    },
    {
      name: 'BaseInfoEditPoiPoi',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditPoi,
      props: true
    }
  ]
}
